module.exports = __webpack_public_path__ + "static/media/ico-rss.dfaab5fb.svg";